const { coreApi } = require('../utils/axios');

async function searchCities({ searchTerm }) {
  const response = await coreApi.post('/cities/search', { searchTerm });

  return response.data.data;
}

const citiesApi = {
  searchCities,
};

export default citiesApi;
